import { useRef } from 'react';

import { useGlass } from '@components/glass/useGlass';
import { Icon } from '@components/ui/Icon';
import { useIsMenuOpen, useToggleMenu } from '@stores/index';
import { cx } from '@utils/cx';

import { MOBILE_MENU_ID } from './ids';
import styles from './MenuButton.module.scss';

/** Opens and closes the mobile navigation sheet. */
export const MenuButton = ({ className }: { readonly className?: string }) => {
  const isOpen = useIsMenuOpen();
  const toggleMenu = useToggleMenu();
  const ref = useRef<HTMLButtonElement>(null);
  const glass = useGlass(ref, {
    variant: 'clear',
    interactive: true,
    className: cx(styles.button, className),
  });

  return (
    <button
      type="button"
      ref={ref}
      className={glass.className}
      style={glass.style}
      data-glass-surface=""
      aria-expanded={isOpen}
      aria-controls={MOBILE_MENU_ID}
      aria-label={isOpen ? 'Close menu' : 'Open menu'}
      onClick={toggleMenu}
    >
      {glass.filter}
      <Icon name={isOpen ? 'close' : 'menu'} size={20} />
    </button>
  );
};
